import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export { LoadAllTextBlocks, SaveTextBlock, AddNewTextBlock, DeleteTextBlock };

function LoadAllTextBlocks(contractId, versionId, editionId, onSuccess, onError) {
    var headers = getAuthHeader();
    axios
        .get(
            process.env.VUE_APP_BASE_API_URL +
                `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/alternativtexts`,
            headers
        )
        .then((response) => {
            onSuccess(response.data);
        })
        .catch((error) => {
            onError(error);
        });
}

function SaveTextBlock(contractId, versionId, editionId, textBlockObject, onSuccess, onError) {
    var headers = getAuthHeader();
    axios
        .put(
            process.env.VUE_APP_BASE_API_URL +
                `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/alternativtexts`,
            textBlockObject,
            headers
        )
        .then((response) => {
            onSuccess(response.data);
        })
        .catch((error) => {
            onError(error);
        });
}

function DeleteTextBlock(contractId, versionId, editionId, textBlockToDeleteId, onSuccess, onError) {
    var headers = getAuthHeader();
    axios
        .delete(
            process.env.VUE_APP_BASE_API_URL +
                `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/alternativtexts/${textBlockToDeleteId}`,
            headers
        )
        .then((response) => {
            onSuccess(response.data);
        })
        .catch((error) => {
            onError(error);
        });
}

function AddNewTextBlock(contractId, versionId, editionId, textBlockObject, onSuccess, onError) {
    var headers = getAuthHeader();
    axios
        .post(
            process.env.VUE_APP_BASE_API_URL +
                `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/alternativtexts`,
            textBlockObject,
            headers
        )
        .then((response) => {
            onSuccess(response.data);
        })
        .catch((error) => {
            onError(error);
        });
}
